var _style, _path, _rect, _rect2, _polygon, _rect3, _polygon2, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleJuice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#004137;}\n\t.st2{fill:#9DC53D;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#662114;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.44,
    y: 47.63,
    className: "st1",
    width: 19.37,
    height: 7.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95.62,
    y: 72.1,
    className: "st1",
    width: 40.29,
    height: 87.71
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.81,54.74 96.42,54.66 95.62,72.11 135.91,72.11 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.28,
    y: 72.1,
    className: "st2",
    width: 40.29,
    height: 87.71
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "96.42,54.66 76.28,72.11 116.56,72.11 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.69,148.03H88.54c-4.34,0-7.85-3.52-7.85-7.85V91.76c0-4.34,3.52-7.85,7.85-7.85h16.15 c4.34,0,7.85,3.52,7.85,7.85v48.41C112.54,144.52,109.02,148.03,104.69,148.03z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.86,105.66c-2.43,0-2.43,0.81-4.86,0.81c-2.43,0-2.43-0.81-4.86-0.81c-3.24,0-7.28,1.62-7.28,7.28 c0,8.9,4.86,16.19,8.09,16.19c2.43,0,2.43-0.81,4.05-0.81c1.62,0,1.62,0.81,4.05,0.81c3.24,0,8.09-7.28,8.09-16.19 C108.14,107.28,104.1,105.66,100.86,105.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96,108.09c-0.45,0-0.81-0.36-0.81-0.81l0,0c0-2.78,0.97-5.35,2.67-7.05c0.32-0.32,0.83-0.32,1.14,0 c0.32,0.32,0.32,0.83,0,1.14c-1.39,1.39-2.19,3.54-2.19,5.9C96.81,107.72,96.45,108.09,96,108.09L96,108.09"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.89,106.94c4.63,5.02,9.66-2.28,9.66-2.28C100.2,101.22,97.89,106.94,97.89,106.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.58,104.39c-0.08-0.3-0.29-0.56-0.58-0.69c-2.79-1.31-5.28-1.56-7.38-0.73 c-2.68,1.05-3.68,3.48-3.72,3.58c-0.15,0.38-0.07,0.82,0.21,1.13c0.11,0.12,0.22,0.23,0.33,0.34c1.35,1.32,2.87,1.9,4.52,1.74 c3.6-0.35,6.37-4.31,6.48-4.48C108.61,105.01,108.67,104.69,108.58,104.39z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleJuice);
export default __webpack_public_path__ + "static/media/Apple_juice.09dfa40652fb76c97cb5fc580b31de33.svg";
export { ForwardRef as ReactComponent };